import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Validators } from '@angular/forms';

import { BaseCrudModalComponent } from 'projects/ProjetoBaseAngular/app/base-crud-modal.component';
import { LayoutLaudoService } from '../../domain/services';
import { LayoutLaudoModel } from '../../domain/models';

@Component({
  selector: 'app-layout-laudo-modal',
  templateUrl: './layout-laudo-modal.component.html'
})
export class LayoutLaudoModalComponent extends BaseCrudModalComponent<LayoutLaudoModel> implements OnInit {
  @ViewChild('modal') modal: ModalDirective;

  constructor(
    injector: Injector,
    service: LayoutLaudoService
  ) {
    super(injector, service);
  }

  protected initializeForm(model: LayoutLaudoModel) {
    this.form = this.formBuilder.group({
      id: model.id,
      dataInclusao: [model.dataInclusao, Validators.required],
      dataAlteracao: model.dataAlteracao,

      nome: [model.nome, [
        Validators.maxLength(50)
      ]],
      texto: [model.texto],
    });
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
